export const formatCurrencyAxisLabel = (value: number): string => {
	if (value >= 1000) {
		const thousands = value / 1000;
		return thousands % 1 === 0 ? `$${thousands}k` : `$${thousands.toFixed(1)}k`;
	}
	if (value > 0 && value < 1) {
		return `$${value.toFixed(2)}`;
	}
	return `$${Math.round(value)}`;
};
